import React, { useState } from "react";

const TABS = [
  { key: "web_platform", label: "Web Platform" },
  { key: "databases", label: "Databases" },
  { key: "cloud_devops", label: "Cloud & DevOps" },
  { key: "mobile_apps", label: "Mobile Apps" },
  { key: "other_frameworks", label: "Other Frameworks" },
];

const TAB_CONTENT = {
  web_platform: [
    { img: "/assets/images/icons/icon_php.svg", title: "PHP" },
    { img: "/assets/images/icons/icon_javascript.svg", title: "JavaScript" },
    { img: "/assets/images/icons/angular-brands.svg", title: "Angular" },
    { img: "/assets/images/icons/vuejs-brands.svg", title: "Vue Js" },
    { img: "/assets/images/icons/icon_typescript.svg", title: "Typescript" },
    { img: "/assets/images/case/icon_python.svg", title: "Python" },
    { img: "/assets/images/icons/svelte.svg", title: "Svelte" },
    { img: "/assets/images/icons/icon_java.svg", title: "Java" },
    { img: "/assets/images/icons/icon_ruby.svg", title: "Ruby" },
    { img: "/assets/images/icons/node-js.svg", title: "Node Js" },
    { img: "/assets/images/icons/icon_react_js.svg", title: "React Js" },
    { img: "/assets/images/icons/icon_laravel.svg", title: "Laraval" },
  ],
  databases: [
    { img: "/assets/images/case/icon_elephent.svg", title: "PostgreSQL" },
    { img: "/assets/images/icons/mariadb-icon-svgrepo.svg", title: "MariaDB" },
    { img: "/assets/images/icons/microsoft-sql-server.svg", title: "Microsoft SQL" },
    { img: "/assets/images/icons/Oracle.svg", title: "Oracle" },
    { img: "/assets/images/icons/Mongodb.svg", title: "MongoDB" },
    { img: "/assets/images/icons/Firebase.svg", title: "Firebase" },
    { img: "/assets/images/icons/Redis.svg", title: "Redis" },
    { img: "/assets/images/icons/Neo4j.svg", title: "Neo4j++" },
    { img: "/assets/images/icons/Elasticsearch.svg", title: "Elastic Search" },
    { img: "/assets/images/icons/icon_laravel.svg", title: "Laraval" },
  ],
  cloud_devops: [
    { img: "/assets/images/icons/Amazon color.svg", title: "Amazon Web Services" },
    { img: "/assets/images/icons/Microsoft azure.svg", title: "Microsoft Azure" },
    { img: "/assets/images/icons/cdnlogo.com_google-cloud.svg", title: "Google Cloud Platform" },
    { img: "/assets/images/icons/Digitalocean.svg", title: "DigitalOcean" },
    { img: "/assets/images/icons/Docker.svg", title: "Docker" },
    { img: "/assets/images/icons/Terraform icon.svg", title: "Terraform" },
    { img: "/assets/images/icons/Gitlab.svg", title: "GitLab" },
    { img: "/assets/images/icons/Cloudflare.svg", title: "Cloudflare" },
  ],
  mobile_apps: [
    { img: "/assets/images/icons/icon_swift.svg", title: "Swift" },
    { img: "/assets/images/icons/Kotlin.svg", title: "Kotlin" },
    { img: "/assets/images/icons/Flutter.svg", title: "Flutter" },
    { img: "/assets/images/icons/Xamarin.svg", title: "Xamarin" },
    { img: "/assets/images/icons/Ionic icon.svg", title: "Ionic" },
    { img: "/assets/images/icons/pwa.svg", title: "Progressive Web Apps" },
    { img: "/assets/images/icons/icon_react_js.svg", title: "React Native" },
  ],
  other_frameworks: [
    { img: "/assets/images/icons/Apachekafka.svg", title: "Apache Kafka" },
    { img: "/assets/images/icons/Rabbitmq icon.svg", title: "RabbitMQ" },
    { img: "/assets/images/icons/Pay pal.svg", title: "PayPal" },
    { img: "/assets/images/icons/Stripe.svg", title: "Stripe" },
    { img: "/assets/images/icons/Wordpress color.svg", title: "WordPress" },
    { img: "/assets/images/icons/Woocommerce icon.svg", title: "WooCommerce" },
    { img: "/assets/images/icons/Shopify.svg", title: "Shopify" },
    { img: "/assets/images/icons/Openai.svg", title: "OpenAI integration" },
    { img: "/assets/images/icons/Shopify.svg", title: "Shopify" },
    { img: "/assets/images/icons/Pytorch.svg", title: "PyTorch" },
    { img: "/assets/images/icons/Tensorflow.svg", title: "TensorFlow" },
    { img: "/assets/images/icons/Websocket.svg", title: "WebSockets" },
    { img: "/assets/images/icons/rest-api-icon.svg", title: "REST APIs" },
    { img: "/assets/images/icons/Graphql.svg", title: "GraphQL" },
    { img: "/assets/images/icons/Apollographql.svg", title: "Apollo" },
  ],
};

function OurTechnologies() {
  const [activeTab, setActiveTab] = useState("web_platform");

  return (
    <section className="process_technology_review_section bg-light section_decoration rounded-bg-section">
      {/* <div className="container"> */}
        <div >
          <div className="heading_block text-center">
            <div
              className="heading_focus_text has_underline d-inline-flex"
              style={{ backgroundImage: "url('/assets/images/shapes/shape_title_under_line.svg')" }}
            >
              Our Technologies
            </div>
            <h2 className="heading_text mb-0">
              We Use <mark>Technologies</mark>
            </h2>
          </div>

          <div className="tab_block_wrapper">
            <ul className="nav justify-content-center" role="tablist">
              {TABS.map((tab) => (
                <li className="nav-item" role="presentation" key={tab.key}>
                  <button
                    className={
                      "nav-link" + (activeTab === tab.key ? " active" : "")
                    }
                    type="button"
                    role="tab"
                    aria-selected={activeTab === tab.key}
                    onClick={() => setActiveTab(tab.key)}
                  >
                    {tab.label}
                  </button>
                </li>
              ))}
            </ul>
            <div className="tab-content">
              {TABS.map((tab) => (
                <div
                  key={tab.key}
                  className={
                    "tab-pane fade" +
                    (activeTab === tab.key ? " show active" : "")
                  }
                  id={`tab_${tab.key}`}
                  role="tabpanel"
                >
                  <div className="web_development_technologies row justify-content-center">
                    {TAB_CONTENT[tab.key].map((tech, idx) => (
                      <div className="col-lg-2 col-md-3 col-sm-4 col-6" key={tech.title + idx}>
                        <div className="iconbox_block text-center p-0 shadow-none bg-transparent">
                          <div className="iconbox_icon">
                            <img src={tech.img} alt={tech.title + " SVG Icon"} />
                          </div>
                          <div className="iconbox_content">
                            <h3 className="iconbox_title mb-0">{tech.title}</h3>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        {/* </div> */}
      </div>
      <div className="decoration_item shape_image_1">
        <img src="/assets/images/shapes/shape_line_2.svg" alt="Shape" />
      </div>
      <div className="decoration_item shape_image_2">
        <img src="/assets/images/shapes/shape_line_3.svg" alt="Shape" />
      </div>
      <div className="decoration_item shape_image_3">
        <img src="/assets/images/shapes/shape_line_4.svg" alt="Shape" />
      </div>
    </section>
  );
}

export default OurTechnologies;
